"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionNode = void 0;
class ExpressionNode {
    formatSubExpression(subExpression) {
        const formattedSubExpression = subExpression.format();
        return subExpression.precedence < this.precedence ? `(${formattedSubExpression})` : formattedSubExpression;
    }
}
exports.ExpressionNode = ExpressionNode;
//# sourceMappingURL=expression-node.js.map